<div
  class="modal fade"
  id="dynamicCompConfirmationModal"
  tabindex="-1"
  aria-labelledby="confirmationModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" [ngClass]="modalSize ? 'modal-' + modalSize : ''">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
        <button
          type="button"
          class="btn-close"
          (click)="onCancel()"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body text-center custom-modal-body">
        <ng-template #dynamicContainer></ng-template>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-outline" (click)="onCancel()">
          {{ cancelButtonText }}
        </button>
        <button type="button" class="btn btn-primary" (click)="onConfirm()">
          {{ confirmButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
